export const event_source = 'hopin';

export const REGISTRATION_EVENTS = {
  REGISTRATION_PAGE_VIEWED: 'Registration Page Viewed',
  REGISTRANT_CSV_BULK_UPLOADED: 'Registrant CSV Bulk Uploaded',
};
